import * as jd from 'jsdataframe';
import {Injectable} from '@angular/core';


export class DfRenameInput {
  selColumns: string[];
  renameColumns: string[];
  dfData: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DfService {

  static dfMerge(arr: any[], joinType: 'inner' | 'outer', by: string): any[] {
    let merged;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].length) {
        const df = jd.dfFromObjArray(arr[i]);
        if (merged) {
          merged = merged.join(df, joinType, {
            'leftBy': [by],
            'rightBy': [by]
          });
        } else {
          merged = df;
        }
      }
    }
    if (merged) {
      return DfService.replaceNaN(merged.toObjArray(), by);
    }
    return [];
  }

  static dfMergeRename(arrs: DfRenameInput[], joinType: 'inner' | 'outer', by: string): any[] {
    let merged = jd.dfFromObjArray(arrs[0].dfData, arrs[0].selColumns);
    merged = merged.setNames(arrs[0].renameColumns);
    for (let i = 1; i < arrs.length; i++) {
      if (arrs[i].dfData.length) {
        let df2 = jd.dfFromObjArray(arrs[i].dfData, arrs[i].selColumns);
        df2 = df2.setNames(arrs[i].renameColumns);
        merged = merged.join(df2, joinType, {
          'leftBy': [by],
          'rightBy': [by]
        });
      } else {
        // add empty column(s)
        for (const col of arrs[i].renameColumns) {
          if (col !== by) {
            merged.insertCol(col, null);
          }
        }
      }
    }
    return DfService.replaceNaN(merged.toObjArray(), by);
  }

  private static replaceNaN(arrIn: any[], by: string): any[] {
    for (let i = 0; i < arrIn.length; i++) {
      for (const key in arrIn[i]) {
        if (arrIn[i].hasOwnProperty(key) && key !== by) {
          arrIn[i][key] = Number.isNaN(arrIn[i][key]) ? null : arrIn[i][key];
        }
      }
    }
    return arrIn;
  }

}
